import React, { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

const Hello = ( { view } ) => {
    const targetRef = useRef( null )
    const { scrollYProgress } = useScroll( {
        target: targetRef,
        offset: ['start end', 'end start'],
    } )

    const opacity = useTransform( scrollYProgress, view === 'web' ? [0, 0.8] : [0, 0.6], [0, 1] )
    const scale = useTransform( scrollYProgress, view === 'web' ? [0, 0.8] : [0, 0.6], [2, 1] )
    return (
        <div>
            <motion.div className='goers' ref={ targetRef } style={ { opacity, scale } }>
                <div className="expertTitle">My Work</div>
                <h3 className="workDes">
                    Software Developer with 6+ years of experience building scalable,
                    high-performance applications using ReactJS, NextJS, NodeJS,
                    MongoDB, Express, AWS, and Terraform. Adept at delivering
                    end-to-end frontend solutions, automation, and cloud integrations.
                    Skilled in creating seamless user experiences, improving system
                    performance, and delivering products under tight deadlines.
                </h3>
            </motion.div>
        </div>
    )
}

export default Hello